export default {
  methods: {
    getNavHash (name) {
      const data = this.nav.find(item => item.name === name)
      return data ? data.hash : ''
    },
  },
}
